var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"opacity":"0.8","value":_vm.isLoading,"z-index":"333"}},[_c('v-img',{attrs:{"max-height":"150","max-width":"150","src":"/assets/image/logo-animation.gif"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }